
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true }"></ngx-loading>
<div class="container">
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header" *ngIf="userdata" style="background:#9b7544; color:#fff">
          <div class="row">
              <div class="col-12">
              <h6 style=" float:left font-family: open sans;"><strong>{{userdata[0].name}}</strong></h6>
              <h6 style="float:right; font-family: open sans;"><strong>Date: {{appointment[0].date}}</strong></h6>
              
              </div>
              </div>
      </div>
      
      <div class="card-body" *ngIf="userdata && appointment ">
            <div class="row">
                  <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3">
                   <img class="img-thumbnail" style=" width: 100%" src="https://passport.petcart.in/images/userimgs/{{userdata[0].image}}"/>
                 </div>
                 <div class="col-sm-4 col-md-9 col-lg-9 col-xl-9">
                   <div class="row">
                     <div class="col-12 center text-center">
                        <div class="card-header" style="margin:2%;background:#dfc473;color:#fff">
                            <div class="row">
                              <div class="col-12 text-center">
                                <h6 style="font-style: open sans;">Schedule</h6>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="font-family: open sans; font-size: 20px">
                            <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                              <p style="font-style: open sans"> Date: {{appointment[0].date}}</p>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                <p style="font-style: open sans"> Start Time:{{appointment[0].start_time}} </p>
                              </div>
                              <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                  <p style="font-style: open sans">End Time: {{appointment[0].end_time}} </p>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                    <p style="font-style: open sans">Status: {{appointment[0].status}} </p> 
                                  </div>
                          </div>
                     </div>
                   </div>

                   <div class="row" *ngIf="pet && service">
                      <div class="col-12 center text-center">
                         <div class="card-header" style="margin:2%;background:#dfc473;color:#fff">
                             <div class="row">
                               <div class="col-12 text-center">
                                 <h6 style="font-style: open sans">Appointment Info</h6>
                               </div>
                             </div>
                           </div>
                           <div class="row" style="font-family: open sans; font-size: 20px">
                              <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                  <img class="img-thumbnail" style="width: 100px" src="https://passport.petcart.in/images/petimages/{{pet.image}}">
                                </div>
                             <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                               <p style="font-style: open sans"> Appointment For: {{pet.pet_name}}</p>
                             </div>
                             <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                 <p style="font-style: open sans"> Pet Type: {{pet.pet_type}} </p>
                               </div>
                               <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                   <p style="font-style: open sans">Reason for Appointment: {{service.name}} </p>
                                 </div>
                                
                           </div>
                      </div>
                    </div>
                  
                   
                </div>
            </div>
            
      </div>
    </div>
  </div>
</div>
<div class="row" style="margin-top:2%; margin-bottom: 2%" >
    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4" *ngIf="appointment && appointment.length > 0 && utime" >
      <button class="btn btn-success2 btn-block" *ngIf="iscancellable(appointment[0].date,appointment[0].start_time) >this.utime && !(appointment[0].status == 'cancelled')" (click)='  cancelAppointment(appointment[0].id,appointment[0].date,appointment[0].start_time)'>Cancel</button>
    </div>
    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4" *ngIf="appointment && appointment.length > 0" >
      <button class="btn btn-success3 btn-block" 
      (click)="uploadpresCription()">Tag Prescription</button>
    </div>
    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <button class="btn btn-secondary btn-block" routerLink = '/doctor/appointment'>Back</button>
      </div>
  </div>
  <div style="margin-top: 10px"  *ngIf="tagdocument && tagdocument.length> 0">
     <div class="card-header text-center" style="background:#9b7544; color: #fff">Tagged Documents
     </div>
     <div class="row" style="margin-top:5px" *ngFor=" let data of tagdocument  | paginate: { itemsPerPage: 3, currentPage: p }">
        <div class="col-3 text-center"  *ngIf= "getFileExtension(data.path) === 'png' 
        || getFileExtension(data.path) === 'jpg'  || getFileExtension(data.path) === 'bmp' ||
         getFileExtension(data.path) === 'gif' ; else textimage">
         <img class="avatar1 "  src="https://passport.petcart.in/images/petimages/{{data.path}}">
        </div>
        <div class="col-3 text-center">{{data.document_type}}</div>
        <div class="col-3 text-center">{{data.subject}}</div>
        <div class="col-3 text-center">
            <a href="https://passport.petcart.in/images/petimages/{{data.path}}" download>
              <mat-icon>file_download</mat-icon>
             </a>
        </div>
      </div>
      <div class="col-12 text-right">
            <pagination-controls  (pageChange)="p = $event"></pagination-controls >
    </div>
  </div>
</div>
<ng-template #textimage>
    <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2 text-center">
        <img class="avatar1 " src="https://passport.petcart.in/images/petimages/doc.png">
    </div>
    
</ng-template>









